import { useJsApiLoader } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import { MAP_LIBRARY, REACT_APP_MAP_KEY_API } from '../common/constants';

/**
 * Custom hook to ensure Google Maps API is fully loaded and ready
 * This hook checks not only if the script is loaded, but also if all required
 * libraries (drawing, places, geometry) are fully initialized
 */
export const useGoogleMapsLoader = () => {
  // const { isLoaded, loadError } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: REACT_APP_MAP_KEY_API || '',
  //   libraries: MAP_LIBRARY,
  //   version: 'weekly',
  //   language: 'en',
  // });

  const [isFullyReady, setIsFullyReady] = useState(false);

  useEffect(() => {
    if (!window.google) {
      setIsFullyReady(false);
      return;
    }

    // Check if window.google.maps exists and is fully initialized
    const checkMapsReady = () => {
      if (
        window.google?.maps &&
        window.google.maps.LatLngBounds &&
        window.google.maps.ControlPosition &&
        window.google.maps.drawing?.OverlayType &&
        window.google.maps.places?.Autocomplete
      ) {
        setIsFullyReady(true);
        return true;
      }
      return false;
    };

    // If already ready, set immediately
    if (checkMapsReady()) {
      return;
    }

    // Otherwise, poll until ready (with timeout)
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait
    const interval = setInterval(() => {
      attempts++;
      if (checkMapsReady() || attempts >= maxAttempts) {
        clearInterval(interval);
        if (attempts >= maxAttempts) {
          console.warn('Google Maps API libraries took too long to initialize');
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [window.google]);

  return {
    isLoaded: isFullyReady,
    loadError : !window.google ? 'Google Maps not loaded' : null,
  };
};

